import { useI18n } from 'builder/hooks/useI18n'
import { TRANSLATION } from '../../constants'
import { Actions, Header, Item, Variant } from '../../../types'

type Steps = Record<Variant, Item[]>

export const useGetConfig = (variant: Variant) => {
  const { i18n } = useI18n()
  const KEY = `${TRANSLATION}.onboarding.steps.welcome`

  const header = i18n.t(`${KEY}.${variant}.info`) as unknown as Header
  const actions = i18n.t(`${KEY}.${variant}.actions`) as unknown as Actions
  const steps: Steps = {
    b: [
      {
        icon: 'tick',
        header: i18n.t(`${KEY}.b.steps.1.header`),
      },
      {
        icon: 'tick',
        header: i18n.t(`${KEY}.b.steps.2.header`),
      },
      {
        icon: 'tick',
        header: i18n.t(`${KEY}.b.steps.3.header`),
      },
      {
        icon: 'tick',
        header: i18n.t(`${KEY}.b.steps.4.header`),
      },
    ],
    c: [
      {
        icon: 'tick',
        header: i18n.t(`${KEY}.c.steps.1.header`),
        description: i18n.t(`${KEY}.c.steps.1.description`),
      },
      {
        icon: 'tick',
        header: i18n.t(`${KEY}.c.steps.2.header`),
        description: i18n.t(`${KEY}.c.steps.2.description`),
      },
      {
        icon: 'tick',
        header: i18n.t(`${KEY}.c.steps.3.header`),
        description: i18n.t(`${KEY}.c.steps.3.description`),
      },
      {
        icon: 'tick',
        header: i18n.t(`${KEY}.c.steps.4.header`),
        description: i18n.t(`${KEY}.c.steps.4.description`),
      },
    ],
  }

  return {
    header,
    actions,
    steps: steps[variant],
  }
}
